import React, { useRef } from 'react';
import styled from 'styled-components';
import { CONSTS } from '../elements/_constants';
import CheckBox from './../elements/checkBox'
import { search } from '../../store/base/functions';
import { connect } from 'react-redux';
import { searchEndAction, changeSearchQueryAction } from '../../store/base/actions';
type SearchBoxProps = {
    className?: string,
    bannerWidth?: string,
    bannerHeight?: string,
    q :string,
    onQueryChange: Function,
    onSearch : Function,
}
const SearchBoxComponent = (props: SearchBoxProps) => {
    let typingTimer :any;
    let q :string;

    const doneTyping = (q :string) => {
        props.onSearch(q);
    }
    const handleKeyDown = (e :any) => {
        // props.onQueryChange(e.target.value);
        clearTimeout(typingTimer);
    }
    const handleKeyUp = (e :any) => {
        clearTimeout(typingTimer);
        q = e.target.value;
        if(q.length > 2)
            typingTimer = setTimeout(() => doneTyping(q), 1000);
    }
    const handleChange = (e :any) => {
        props.onQueryChange(e.target.value);
    }

    return(
        <div className={props.className}>
            <div className="_header">
                <div className="_title">
                    جستجو در سامانه
                </div>
                {/* <div className="_filter">
                    <div className="_selection-title">
                        بخش های مورد نظر برای جستجو :
                    </div>
                    <div className="_selection-items">
                        <CheckBox label="فرم‌ها" style={{marginLeft:11}}/>
                        <CheckBox label="لیست‌ها" style={{marginLeft:11}}/>
                        <CheckBox label="پست‌ها" style={{marginLeft:11}}/>
                    </div>
                </div> */}
            </div>
            <div className="_container">
                
                <div className="_icon icon-icons8-search" spellCheck={false}/>
                <input onKeyUp={handleKeyUp} onKeyDown={handleKeyDown} placeholder="جستجو" value={props.q} onChange={handleChange}/>
            </div>
        </div>
    )
}
const SearchBox = styled(SearchBoxComponent)`
    width: calc(100% - ${props=>props.bannerWidth} - 30px);
    height: ${props=>props.bannerHeight};
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
        width: 100%;
        margin-bottom: 20px;
        height: auto;
    }
    ._container {
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0 0 0 1px rgba(63,63,68,0.05);
        border-radius: 8px;
        height: 45px;
        margin-top: 19px;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            margin-top: 0px;
        }
        position: relative;
        input {
            width: calc(100%);
            border: 0;
            outline: none;
            background: transparent;
            height: 100%;
            font-family: ${CONSTS.fonts.primary.light};
            font-size: 14px;
            padding-right: 15px;
            padding-left: 50px;
            box-sizing: border-box;
            color: ${CONSTS.colors.primaryDark};
            transition: ease all .2s;
            border-radius: 8px;
            &::placeholder {
                color: rgba(0,0,0,.3);
            }
            &:hover {
                background: rgba(255,255,255,0.02);
            }
            &:focus{
                box-shadow: 0 2px 10px rgba(0,0,0,.05);
            }
        }
        ._icon {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row;
            top: 0;
            left: 0;
            width: 48px;
            height: 45px;
            font-size: 25px;
            color: ${CONSTS.colors.primary};
            cursor: pointer;
            transition: cubic-bezier(0.52, 0.01, 0.56, 1.34) all .2s;
            z-index: 1000;
            border-radius: 8px 0 0 8px;
            &:hover {
                background: ${CONSTS.colors.primaryLight};
            }
        }
    }
    ._header {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: space-between;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            display: none;
        }
        ._title {
            font-family: ${CONSTS.fonts.primary.bold};
            font-size: 16px;
            color: ${CONSTS.colors.primary};
            letter-spacing: -1px;
        }
        ._filter {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            ._selection-title {
                font-family: ${CONSTS.fonts.primary.extraLight};
                font-size: 14px;
                color: ${CONSTS.colors.greyDark};
                letter-spacing: -1px;
                padding-left: 10px;
            }
            ._selection-items {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }
`

const mapDispatchToProps = (dispatch :Function) => ({
    onQueryChange: (q:string) => dispatch(changeSearchQueryAction(q)),
    onSearch : (q :string) => dispatch(search(q)),
})
export default connect(null, mapDispatchToProps)(SearchBox);